<template>
    <div>
        <base-header type="gradient-default" class="pb-7 pt-5 pt-md-8">
        </base-header>

        <div class="container-fluid mt--9">
            <div class="row">
                <div class="col-12">
                    <div class="card card-profile shadow">
                        <div class="card-body pt-0 pt-md-4">
                            <div class="text-center">
                                <h1>
                                    {{entidade.ent_nome}}
                                </h1>
                                <div class="h5 font-weight-300">
                                    {{entidade.ent_cnpj | VMask('##.###.###/####-##')}}
                                </div>
                                <hr class="my-4"/>
                                <div v-show="entidade.ent_email" class="mt-3">
                                    <i class="fas fa-at"></i> {{entidade.ent_email}}
                                </div>
                                <div v-show="entidade.ent_telefone" class="mt-3">
                                    <i class="fas fa-phone-alt"></i> {{entidade.ent_telefone | VMask('(##) ####-####') }}
                                </div>
                                <div v-show="entidade.ent_endereco" class="mt-3">
                                    <i class="fas fa-map-marker-alt"></i> {{entidade.ent_endereco}}
                                </div>
                                <div class="h5">
                                    {{entidade.ent_municipio}} - {{entidade.ent_uf}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import Vue from 'vue'
  import { VueMaskFilter } from 'v-mask'
  Vue.filter('VMask', VueMaskFilter)
  export default {
    name: 'user-profile',
    data() {
      return {}
    },
    computed: {
      entidade() {
        return this.$store.getters.entidade;
      }
    }
  };
</script>
<style></style>
